/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskDetails } from '@/task-manager/entities/task-details';
import { Optimistic } from '@/utils/react-query/optimistic';

import { type BodyOf, tasksV1CardsUnsubscribeCreate } from '../fetch-client';
import { GetTask } from '../queries/get-task';
import { useFetchOpts } from '../use-fetch-opts';

export namespace UnsubscribeTask {
  export type Params = { onSuccess?: () => Promise<void> | void };
  export type Input = { id: string };
  export type Output = void;

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsUnsubscribeCreate> {
    return {
      uuid: input.id,
    };
  }

  export function useMutation(params?: Params) {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CardsUnsubscribeCreate(body, opts));
        return;
      },
      onMutate({ id }) {
        queryClient.cancelQueries(GetTask.key({ id }));
        queryClient.setQueryData(
          GetTask.key({ id }),
          GetTask.optimistic((previous) => ({
            ...previous,
            task: Optimistic.updateEntity<TaskDetails>(previous.task, {
              isSubscribed: false,
            }),
          })),
        );
      },
      async onSuccess() {
        await params?.onSuccess?.();
      },
      async onSettled(_, __, { id }) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: GetTask.key({ id }),
          }),
        ]);
      },
    });
  }
}
